import React from "react";
import PropTypes from "prop-types";
import {
    Timeline,
    Tag,
    Popconfirm,
    Button,
    Typography
} from "antd";

const { Text } = Typography;

class SingleDayNotes extends React.Component {

    getNotes = (_) => {
        const note = _.notes.includes(":") && _.notes.split(":");
        if(note && note[2] && note[2] !== " None") {
            let data = note.slice(2, note.length).join("");

            return data;
        }

        return null;
    }

    deleteThisNote = (note) => {
        this.props.deleteNote(note.id);
    }

    activateNote = (note) => {
        this.props.activateNote(note.id);
    }

    getInitialNotes = (_) => {
        if(_.notes.includes(":")) {
            return <b>{_.notes.split(":")[0]}</b>;
        }
        return _.notes;
    }

    render() {
        return (
            <Timeline className={"p-10"}>
                {
                    this.props.notes &&
                    (this.props.notes.length || this.props.notes.size) &&
                    this.props.notes
                        .map(_ => (
                            _.notes ? (
                                <Timeline.Item key={_.id}>
                                    <div>
                                        <Tag>
                                            {_.create_date.format("LT")}
                                        </Tag>
                                        <Tag>
                                            {
                                                _.user &&
                                                _.user.full_name
                                            }
                                        </Tag>
                                    </div>
                                    <div>
                                        {_.is_active ? this.getInitialNotes(_) : (
                                            <Text delete>
                                                {this.getInitialNotes(_)}
                                            </Text>
                                        )}
                                    </div>
                                    <div>
                                        {
                                            _.notes.includes(":") &&
                                                _.notes.split(":")[1] && 
                                                _.notes.split(":")[1] !== " None" ?
                                                _.notes.split(":")[1] :
                                                null
                                        }
                                        {_.is_active ? this.getNotes(_) : (
                                            <Text delete>
                                                {this.getNotes(_)}
                                            </Text>
                                        )}
                                        {this.props.deleteNote && <Popconfirm
                                            title={_.is_active ? "Are You sure, this comment will not be visible to Bank ?" : "Are you sure, this comment will be visible to bank ?"}
                                            onConfirm={_.is_active ? this.deleteThisNote.bind(null, _) : this.activateNote.bind(null, _)}
                                            onCancel={null}
                                            okText={"Yes"}
                                            cancelText={"No"}
                                        >
                                            <Button icon={_.is_active ? "delete" : "redo"} type={"link"}>{_.is_active ? "Hide" : "Retrieve"}</Button>
                                        </Popconfirm>}
                                    </div>
                                </Timeline.Item>
                            ) : null
                        ))
                }
            </Timeline>
        );
    }
}

SingleDayNotes.propTypes = {
    notes: PropTypes.object,
    deleteNote: PropTypes.func,
    activateNote: PropTypes.func
};

export default SingleDayNotes;